/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SessionLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SessionLanguagesQuery = { languages: Array<{ code: string, localizedLabel: string, translatedLabel: string }> };


export const SessionLanguagesDocument = gql`
    query SessionLanguages {
  languages {
    code
    localizedLabel: localized_label
    translatedLabel: translated_label
  }
}
    `;

/**
 * __useSessionLanguagesQuery__
 *
 * To run a query within a React component, call `useSessionLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<SessionLanguagesQuery, SessionLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionLanguagesQuery, SessionLanguagesQueryVariables>(SessionLanguagesDocument, options);
      }
export function useSessionLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionLanguagesQuery, SessionLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionLanguagesQuery, SessionLanguagesQueryVariables>(SessionLanguagesDocument, options);
        }
export type SessionLanguagesQueryHookResult = ReturnType<typeof useSessionLanguagesQuery>;
export type SessionLanguagesLazyQueryHookResult = ReturnType<typeof useSessionLanguagesLazyQuery>;
export type SessionLanguagesQueryResult = Apollo.QueryResult<SessionLanguagesQuery, SessionLanguagesQueryVariables>;